<template>
  <div>
    <header>
      <h3>{{ $t("dashboard-activity-title") }}</h3>
      <nav>
        <ul>
          <li
            @click="filterActivities('all')"
            :class="{ active: activityFilter === 'all' }"
          >
            <a>{{ $t("dashboard-activity-filter-all") }}</a>
          </li>
          <li
            @click="filterActivities('outgoing')"
            :class="{ active: activityFilter === 'outgoing' }"
          >
            <a>{{ $t("dashboard-activity-filter-sent") }}</a>
          </li>
          <li
            @click="filterActivities('incoming')"
            :class="{ active: activityFilter === 'incoming' }"
          >
            <a>{{ $t("dashboard-activity-filter-received") }}</a>
          </li>
        </ul>
      </nav>
    </header>
    <div :class="['activity-list', activityFilter]" v-if="activity.length">
      <div
        v-for="(item, index) in activity"
        :key="index"
        :class="['activity', item.activityType.split('_')[0].toLowerCase()]"
      >
        <activity-item :activity="item"></activity-item>
      </div>
    </div>
    <div v-else class="activity-list empty">
      <div class="activity">
        <p>{{ $t("dashboard-empty-activity") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ActivityItem from "./ActivityItem";

export default {
  name: "Activity",
  components: {
    ActivityItem
  },
  data() {
    return {
      activityFilter: "all"
    };
  },
  computed: {
    ...mapState("activity", ["activity"])
  },
  methods: {
    filterActivities(filter) {
      this.activityFilter = filter;
    }
  },
  created() {
    this.$store.dispatch("activity/getActivities");
  }
};
</script>

<style scoped lang="scss">
@import "../../../../../assets/styles/variables";

header {
  display: flex;
  justify-content: space-between;
  padding: 15px 20px;
  border-bottom: 1px solid #d8d8d8;
  > h3 {
    margin: 0;
  }
  nav {
    ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
      > li {
        display: inline-block;
        font-size: 14px;
        &.active {
          a {
            color: $deadblue;
          }
        }
        &:not(:last-child) {
          margin-right: 25px;
        }
      }
    }
  }
}
.activity-list {
  overflow: auto;
  height: calc(100vh - 136px);
  &.empty {
    p {
      margin: 0;
    }
  }
  &.incoming {
    .activity:not(.incoming) {
      display: none;
    }
  }
  &.outgoing {
    .activity:not(.outgoing) {
      display: none;
    }
  }
  .activity {
    border-bottom: 1px solid #d8d8d8;
    padding: 15px 20px;
    p {
      color: black;
      margin: 5px 0;
    }
    small {
      font-size: 12px;
      color: $placeholder-color;
    }
  }
}
</style>
